import Vuex from 'vuex'
import Vue from 'vue'
// import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        loading:'',
        titleData:[],
        isEnable:true,
        newdetail:[],
        intervalIndex:'',
        activityTypeIndex:'',
        provinceIndex:'',
        SFprovinceIndex:'',
        enrollStatusIndex:'',
        AreaList:[],
        areaId:'',
        musicianTypeIndex:'',
        firstTypeIndex:'',
        specialityIdIndex:'',
        SFspecialityIdIndex:'',//筛选星光
        TspecialityIdIndex:'',//筛选师资
        areaIdIndex:'',
        MusicalIndex:'',
        MusicIndex:'',
        KnowledgeTypeIndex:'',
        RecruitTypeIndex:'',
        KnowledgeTypeList:[],
        appMusicalIndex:'',
        appMusicIndex:'',
        bandDetail:'',
        isShowGoTop:''
    },
    getters:{

    },
    mutations:{
        // 骨架屏
        loading(state,payload){
            // console.log(payload)
            state.loading = payload
        },
        // 获取标题数据
        getTitleData(state,payload){
            state.titleData = payload
        },
        // 判断过滤弹窗打开时，禁止滑动
        isShowHandle(state,payload){
            state.isEnable = payload
        },
        // 资讯详情
        newDetailHandle(state,payload){                                     
            state.newdetail = payload
        },
        // 时段
        intervalHandle(state,payload){
            state.intervalIndex = payload
        },    
        // 分类
        activityTypeHandle(state,payload){
            state.activityTypeIndex = payload
        },
        // 省份
        provinceHandle(state,payload){
            state.provinceIndex = payload
        },
        // 省份---星光
        SFprovinceHandle(state,payload){
            state.SFprovinceIndex = payload
        },
        // 状态
        enrollStatusHandle(state,payload){
            state.enrollStatusIndex = payload
        },
        // 城市种类
        AreaListHandle(state,payload){
            state.AreaList = payload
        },
        // 城市id
        areaIdHandle(state,payload){
            state.areaId = payload
        },
        // 专家分类
        musicianTypeHandle(state,payload){
            state.musicianTypeIndex = payload
        },
        // 专业大类
        firstTypeIndexHandle(state,payload){
            state.firstTypeIndex = payload
        },
        // 职业/特长
        specialityIdHandle(state,payload){
            state.specialityIdIndex = payload
        },
        // 职业特长---星光
        SFspecialityIdHandle(state,payload){
            state.SFspecialityIdIndex = payload
        },
        // 职业特长---星光
        TspecialityIdHandle(state,payload){
            state.TspecialityIdIndex = payload
        },
        // 城市
        areaIdIndexHandle(state,payload){
            state.areaIdIndex = payload
        },
        //乐谱汇 乐器
        MusicalIndexHandle(state,payload){
            state.MusicalIndex = payload
        },
        //乐谱汇 音乐
        MusicIndexHandle(state,payload){
            state.MusicIndex = payload
        },
         // 人才招募 分类索引
         RecruitTypeHandle(state,payload){
            state.RecruitTypeIndex = payload
        },
        // 知识汇 分类索引
        KnowledgeTypeHandle(state,payload){
            state.KnowledgeTypeIndex = payload
        },
        // 知识汇的分类列表
        KnowledgeTypeList(state,payload){
            state.KnowledgeTypeList = payload
        },
        // 音乐欣赏 乐器
        AppMusicalIndexHandle(state,payload){
            state.appMusicalIndex = payload
        },
        // 音乐欣赏 音乐
        AppMusicIndexHandle(state,payload){
            state.appMusicIndex = payload
        },
        // 乐队天地 资讯详情
        bandDetailHandle(state,payload){
            console.log(payload)
            state.bandDetail = payload
        },
        // 滚动到顶部隐藏图标
        isShowGoTopHandle(state,payload){
            // console.log(payload)
            state.isShowGoTop = payload
        }

    },
    actions:{
      
 
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js